<template>
  <div class="px-4 mt-4 container-fluid">
    <div class="row">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Ventas (últ. 7d.)"
          :value=formatoImporte(totalVentas.bruto,true)
          :percentage="{
            value: parseFloat(totalVentas.incremento).toFixed(1) + '%',
            color: totalVentas.incremento>0 ? 'text-success' : 'text-danger',
          }"
          :icon="{
            component: 'ni ni-cart',
            background: iconBackground,
          }"
          :adicional="totalVentas.cuantos + ' ventas finalizadas'"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Usuarios activos (últ. 7d.)"
          :value="totalUsuarios.activos"
          :percentage="{
            value: parseFloat(totalUsuarios.incremento).toFixed(1) + '%',
            color: totalUsuarios.incremento>0 ? 'text-success' : 'text-danger',
          }"
          :icon="{
            component: 'ni ni-world',
            background: iconBackground,
          }"
          :adicional="totalUsuarios.cuantos + ' activos el últ. año'"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Productos activos (últ. 7d.)"
          :value="totalProductos.activos"
          :percentage="{
            value: parseFloat(totalProductos.incremento).toFixed(1) + '%',
            color: totalProductos.incremento>0 ? 'text-success' : 'text-danger',
          }"
          :icon="{
            component: 'ni ni-box-2',
            background: iconBackground,
          }"
          :adicional="totalProductos.cuantos + ' activo últ. año'"
          direction-reverse
        />
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
        <mini-statistics-card
          title="Tipsters activos (últ. 7d.)"
          :value="totalTipsters.activos"
          :percentage="{
            value: parseFloat(totalTipsters.incremento).toFixed(1) + '%',
            color: totalTipsters.incremento>0 ? 'text-success' : 'text-danger',
          }"
          :icon="{
            component: 'ni ni-briefcase-24',
            background: iconBackground,
          }"
          :adicional="totalTipsters.cuantos + ' activo últ. año'"
          direction-reverse
        />
      </div>
    </div>
    <div class="row my-4">
      <div class="col-lg-8 col-md-6">
        <div class="card z-index-2 mb-5">
          <gradient-line-chart
            id="chart-line"
            title="Evolución de ventas"
            :trend-icon="'fa fa-arrow-up ' + (graficoVentas.incremento < 0 ? 'text-danger' : 'text-success')"
            :trend-value="parseFloat(graficoVentas.incremento).toFixed(1) + '%'"
            :description="'en ' + graficoVentas.actual"
            :loading="loading"
            :chart="{
              labels: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
              datasets: [
                {
                  label: graficoVentas.actual,
                  data: graficoVentas.serie_act,
                  tension: 0.4,
                  borderWidth: 3,
                  borderColor: '#f5a623',
                  backgroundColor: 'rgba(245,166,35,0.15)',
                  fill: true,
                },
                {
                  label: graficoVentas.anterior,
                  data: graficoVentas.serie_ant,
                  tension: 0.4,
                  borderWidth: 3,
                  borderColor: '#66c0a6',
                  backgroundColor: 'rgba(102,192,166,0.15)',
                  fill: true,
                },
              ],
            }"
          />
        </div>
        <projects-card 
          title="Ventas por Tipster"
          :loading="loading"
          :cuantos="totalTipsters.activos + ' tipsters'"
          :ventas="ventasTipsters"
        />
      </div>

      <!-- Columna derecha --> 
      <div class="col-lg-4 col-md-6">
        <timeline-list
          class="h-100"
          title="Últimas ventas"
          description="<i class='fa fa-arrow-right text-success' aria-hidden='true'></i> Ventas más recientes"
        >
          <TimelineItem v-for="v in ventasTodas" :key="v.id"
            color="success"
            icon="check-bold"
            :title="v.nomproducto + ' - ' + v.nomtipster"
            :date-time="v.fecha"
            :texto="formatoImporte(v.precio,true)"
          />
        </timeline-list>
      </div>
    </div>
  </div>
</template>
<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import TimelineList from "./components/TimelineList.vue";
import TimelineItem from "./components/TimelineItem.vue";
import ProjectsCard from "./components/ProjectsCard.vue";
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

import {
  faHandPointer,
  faUsers,
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";

export default {
  name: "dashboard-default",
  data() {
    return {
      iconBackground: "bg-tipster",
      faCreditCard,
      faScrewdriverWrench,
      faUsers,
      faHandPointer,
      totalVentas:    { bruto: 0, incremento: 0, cuantos: 0 },
      totalUsuarios:  { activos: 0, incremento: 0, cuantos: 0 },
      totalProductos: { activos: 0, incremento: 0, cuantos: 0 },
      totalTipsters:  { activos: 0, incremento: 0, cuantos: 0 },
      graficoVentas:  { incremento: 0, actual: '', anterior: '', serie_act: [], serie_ant: [] },
      ventasTipsters: [],
      ventasTodas:    [],
      loading: true,
    };
  },
  mixins: [globalFunctionsMixin],
  components: {
    MiniStatisticsCard,
    GradientLineChart,
    ProjectsCard,
    TimelineList,
    TimelineItem,
  },

  async mounted() { 
    try {
        this.loading = true;
        const resp = await this.$store.dispatch("auth/estadisticas");
        if (resp.res=='OK') {
            this.totalVentas = resp.ventas['totales']; 
            this.graficoVentas = resp.ventas['grafico']; 
            this.totalUsuarios = resp.usuarios['totales']; 
            this.totalProductos = resp.productos['totales']; 
            this.totalTipsters = resp.tipsters['totales']; 
            this.ventasTipsters = resp.tipsters['ventas']; 
            this.ventasTodas = resp.ventas['todas'];
        }
        this.loading = false;
    }
    catch (error) {
      console.error('Dashboard error:', error);
    }
  },
};
</script>
